import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const NotFoundPage = () => {
  const { user } = useAuth();

  const getHomeLink = () => {
    if (!user) return '/';
    if (user.role === 'coach') return '/coach/dashboard';
    if (user.role === 'client') return '/user/coaches';
    return '/';
  };

  const getHomeLinkText = () => {
    if (!user) return 'Go to Home';
    if (user.role === 'coach') return 'Go to Dashboard';
    if (user.role === 'client') return 'Browse Coaches';
    return 'Go to Home';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-extrabold text-gray-200">404</h1>
          <div className="relative -mt-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <Link
            to={getHomeLink()}
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
          >
            {getHomeLinkText()}
          </Link>
          
          <div className="text-center">
            <Link
              to="/login"
              className="text-blue-600 hover:text-blue-500 font-medium"
            >
              Sign In
            </Link>
            {' | '}
            <Link
              to="/register"
              className="text-blue-600 hover:text-blue-500 font-medium"
            >
              Register
            </Link>
          </div>
        </div>

        <div className="mt-12 text-gray-500 text-sm">
          <p>If you believe this is an error, please contact support.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
